import { AuctionState } from '../../../components';
import { APIListingAuctionStatus } from '../types';

/**
 * Maps over the API Listing item's underlying auction status and formats the correct value for displaying in the listing card
 */
export function mapAuctionStatus(
  apiAuctionStatus: APIListingAuctionStatus
): AuctionState {
  switch (apiAuctionStatus) {
    case 'Sold':
      return 'sold';
    case 'Unsold':
      return 'unsold';
    case 'Pending':
      return 'pending';
    case 'Active':
    default:
      return 'active';
  }
}
